"use strict";

import Immutable from 'immutable';
import Fluxxor from 'fluxxor';

import moment from 'ofs/moment';
import Constants from 'ofs/apps/core/constants';


var UnitStore = Fluxxor.createStore({
  actions: {},

  initialize(options) {
    this.setMaxListeners(0);
    this.state = Immutable.fromJS(options);
  }
});

export default UnitStore;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/legacy/property/default/stores/UnitStore.js
 **/